import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { getSpeakers, getTalks } from '../utils/services';
import talksMock from '../mocks/talks.json';
import speakersMock from '../mocks/speakers.json';

const { Consumer, Provider } = React.createContext();

const ProgramProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [talks, setTalks] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const [selectedTalk, setSelectedTalk] = useState('');
  const TALKS = talksMock;
  const SPEAKERS = speakersMock;

  const loadProgram = async () => {
    setIsLoading(true);
    try {
      // const loadedTalks = await getTalks();
      // const loadedSpeakers = await getSpeakers();
      const loadedTalks = TALKS;
      const loadedSpeakers = SPEAKERS;
      setTalks(loadedTalks);
      setSpeakers(loadedSpeakers);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Provider
      value={{
        isLoading,
        talks,
        selectedTalk,
        speakers,
        setSelectedTalk,
        loadProgram
      }}>
      {children}
    </Provider>
  );
};

ProgramProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { ProgramProvider, Consumer as ProgramConsumer };
